import { useTranslation } from 'react-i18next';
import { MyLink } from '@/components/MyLink';
import { APP_LINKS } from '@/helpers/links';
import { DashboardBonusCard } from '../DashboardBonusCard';
import IconInvite from '@scramble/design-system/icons/user-plus-01.svg';

export const InviteFriendsCard = () => {
  const { t } = useTranslation('dashboard');
  return (
    <DashboardBonusCard
      title={t('dashboard:offer_invite.invite_friends')}
      text={t('dashboard:offer_invite.reward_description')}
      icon={<img src={IconInvite} alt="icon" width={24} height={24} />}
      footer={
        <MyLink href={APP_LINKS.affiliate}>
          {t('dashboard:offer_invite.share_scramble')}
        </MyLink>
      }
    />
  );
};
